export default __webpack_public_path__ + "static/media/questionIcon.2afe37a2.svg";